export default function Logo({ size = 36, className = "" }) {
  return (
    <img
      src="/inthink-mark.png"
      alt="InThink"
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className={`inline-block object-contain ${className}`}
      data-testid="app-logo"
      draggable={false}
    />
  );
}
